import { jsx as _jsx } from "react/jsx-runtime";
import { Environment } from '@as-react/common-utils';
import { memo, useEffect, useState } from 'react';
import { HtmlInclude } from '../html-include/HtmlInclude';
import { axiosClient } from '@as-react/common-utils';
import { Logger } from '@as-react/logger';
const EsiInclude = props => {
    const [mockEsiData, setMockEsiData] = useState();
    const setEsiTag = () => {
        return `
            <esi:try> 
                <esi:attempt>
                    <esi:include src="${props.url}"/> 
                </esi:attempt>
                <esi:except> 
                    <esi:comment text="Just write some HTML instead"/> 
                </esi:except> 
            </esi:try>`;
    };
    const setEsiScript = () => {
        return `SITE.data.${props.dataKey} = SITE.dataImporter(<esi:include src="${props.url}"/>);`;
    };
    useEffect(() => {
        if (Environment.isDevelopment()) {
            const axiosConfig = {
                method: 'GET',
                url: `${props.url}`,
            };
            axiosClient
                .request(axiosConfig)
                .then(response => {
                if (props.dataKey) {
                    SITE.data[props.dataKey] = response.data;
                    props.throwAction(response.data);
                }
                else {
                    setMockEsiData(response.data);
                }
            })
                .catch(Logger.logError);
        }
    }, [props.url]);
    useEffect(() => {
        if (Environment.isDevelopment() && mockEsiData) {
            typeof props.onDataLoaded === 'function' && props.onDataLoaded();
        }
    }, [props.onDataLoaded, mockEsiData]);
    if (Environment.isProduction() && props.dataKey) {
        return _jsx(HtmlInclude, { scriptFragment: setEsiScript() });
    }
    else if (Environment.isProduction()) {
        return _jsx(HtmlInclude, { htmlFragment: setEsiTag() });
    }
    else if (props.dataKey) {
        return null;
    }
    return _jsx(HtmlInclude, { htmlFragment: mockEsiData });
};
export default memo(EsiInclude);
